import { BillboardImage, BillboardImageRef, BillboardRenderer, Layer, View } from "@hscmap/stellar-globe";
import { LayerComponentBase } from "@/stellar-globe-components";
import { deepEqual } from "@/utils/deep";
import { V3, V4 } from "@/utils/math";
import { Component, Prop, Watch } from "vue-property-decorator";
import { markerImageData, MarkerStyle } from "./marker";

export class MarkerLayer extends Layer {
  br!: BillboardRenderer

  constructor(private coord3: V3[], public color: V4, private marker: MarkerStyle) {
    super()
  }

  onAdd() {
    this.br = new BillboardRenderer(this.globe.gl)
    this.br.color = this.color
    this.rebuild()
  }

  onRemove() {
    this.br.release()
  }

  private rebuild() {
    if (this.coord3.length > 0) {
      const imageRefs: BillboardImageRef[] = []
      const marker: BillboardImage = {
        imageData: markerImageData(this.marker),
        origin: [0, 0],
      }
      for (const coord of this.coord3) {
        imageRefs.push({
          imageID: 0,
          position: coord,
        })
      }
      this.br.buildArray([marker], imageRefs)
      this.globe.requestRefresh()
    }
  }

  setCoord3(coord3: V3[]) {
    this.coord3 = coord3
    this.rebuild()
  }

  setMarker(marker: MarkerStyle) {
    this.marker = marker
    this.rebuild()
  }

  render(view: View) {
    if (this.coord3.length > 0) {
      this.br.render(view)
    }
  }
}

@Component
export default class MarkerLayerComponent extends LayerComponentBase<MarkerLayer> {
  @Prop({ required: true })
  coord3!: V3[]
  @Watch('coord3')
  onCoordChange(newCoord3: V3[], oldCoord3: V3[]) {
    if (!deepEqual(newCoord3, oldCoord3)) {
      this.layer.setCoord3(newCoord3)
    }
  }

  @Prop({ required: true })
  color!: V4
  @Watch('color')
  onColorChange() {
    this.layer.br.color = this.color
    this.globe.requestRefresh()
  }

  @Prop({ required: true })
  marker!: MarkerStyle
  @Watch('marker')
  onMarkerChagne() {
    this.layer.setMarker(this.marker)
  }

  newLayer() {
    return new MarkerLayer(this.coord3, this.color, this.marker)
  }
}
